<template>
  <div class="content-address">
    <h2>Endereço de entrega</h2>
    <div class="info delivery-address">
      {{ data.shipping.street }}, {{ data.shipping.number }}, {{ data.shipping.district }} - {{ data.shipping.city }} ({{ data.shipping.state }}) {{ data.shipping.zip }}
    </div>
    <h2>Endereço SPC <div v-b-tooltip.hover :title="check.endereco" :class="addressStatus === 'OK' ? 'icon success' : addressStatus === 'REVIEW' ? 'icon warning' : 'icon danger'"><i class="icon-location-2"></i></div></h2>
    <div class="info spc-address">
      {{ data.spc.street }}, {{ data.spc.number }} - {{ data.spc.city }} ({{ data.spc.state }}) {{ data.spc.zip }}
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      data: []
    }
  },
  mounted () {
    this.getCustomerAddress()
  },
  methods: {
    getCustomerAddress () {
      this.$http.get('api/order-validation/' + this.$route.params.txid + '/customer-address')
        .then(function (res) {
          this.data = res.data
        })
        .catch(function (res) {
          console.error(res)
        })
    }
  },
  props: ['addressStatus', 'check']
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/partial/customer/CustomerAddress.vue